import { Box, BoxProps, Stack, Typography, useTheme } from '@mui/material';
import { useFormatShortcut } from 'src/utils/system';

type ShortcutTextProps = {
  shortcut: string;
  label?: string;
  size?: 'small' | 'medium' | 'large';
} & Omit<BoxProps, 'size'>;

export const ShortcutText = (props: ShortcutTextProps) => {
  const { shortcut, size = 'medium', label, ...rest } = props;
  const theme = useTheme();
  const formatShortcut = useFormatShortcut();
  return (
    <Stack direction="row" alignItems="center">
      {!!label && (
        <Typography variant="body2" fontSize="inherit">
          {label}
        </Typography>
      )}
      <Box
        component="span"
        ml={label ? 1 : 0}
        sx={{
          alignSelf: 'flex-start',
          alignItems: 'center',
          justifyContent: 'center',
          display: 'inline-flex',
          borderRadius: '0.25rem',
          borderStyle: 'solid',
          borderWidth: '1px',
          borderColor: theme.palette.custom.OV.sys.outline,
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          textAlign: 'center',
          ...(size === 'small' && {
            fontSize: '0.5rem',
            minWidth: '1.3rem',
            minHeight: '1.3rem',
            padding: '0.2rem 0.3rem',
            lineHeight: '0.2rem',
          }),
          ...(size === 'medium' && {
            fontSize: '0.75rem',
            minWidth: '1.6rem',
            minHeight: '1.6rem',
            padding: '0 0.4rem',
            lineHeight: '0.75rem',
          }),
          ...(size === 'large' && {
            fontSize: '1rem',
            minWidth: '2rem',
            padding: '0.3rem 0.4rem',
            lineHeight: '1rem',
          }),
        }}
        {...rest}
      >
        {formatShortcut(shortcut)}
      </Box>
    </Stack>
  );
};
